import { render, staticRenderFns } from "./StudyDefinitionForm.vue?vue&type=template&id=2f47fc7c&scoped=true"
import script from "./StudyDefinitionForm.vue?vue&type=script&lang=js"
export * from "./StudyDefinitionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f47fc7c",
  null
  
)

export default component.exports